import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fetchTestimonials } from "../redux/testimonialsSlice";
import { FiStar, FiMessageCircle } from "react-icons/fi";

export const Testimonials = (props) => {
  const seo = props?.seo || {};
  const dispatch = useDispatch();
  const { testimonials } = useSelector((state) => state.testimonials);

  useEffect(() => {
    dispatch(fetchTestimonials({ page: 1, limit: 1000 }));
  }, [dispatch]);

  // Statik fallback veriler
  const testimonialsData = [
    {
      content:
        "Çocuğumuzun dikkat dağınıklığı konusunda destek aldık. Dilan Aslan Çocuk Gelişim Danışmanlığı sayesinde günlük rutinlerimiz daha düzenli hale geldi.",
      fullName: "Ayşe K.",
    },
    {
      content:
        "Oğlum için oyun terapisi desteği aldık. Dilan Hanım'ın sıcak yaklaşımı sayesinde kısa sürede olumlu gelişmeler gördük. Kesinlikle tavsiye ederim!",
      fullName: "Murat T.",
    },
    {
      content:
        "Çocuk gelişim danışmanlığı sayesinde kızımızın özgüveni arttı. Hem bize rehberlik ettiler hem de çocuğumuzla harika bir bağ kurdular.",
      fullName: "Elif A.",
    },
    {
      content:
        "Dil gelişimi konusunda destek aldık. Yapılan çalışmalar çok verimli geçti ve çocuğumuzun kendini ifade etmesi belirgin şekilde gelişti.",
      fullName: "Erkan B.",
    },
    {
      content:
        "Aile danışmanlığı sürecinde bize yol gösterdiler. Çocuğumuzla iletişimimiz çok daha sağlıklı hale geldi. Güvenimiz tam.",
      fullName: "Nesrin Y.",
    },
    {
      content:
        "Özel eğitim ihtiyacı olan çocuğumuz için bireysel destek aldık. Hem akademik hem de sosyal anlamda büyük ilerleme kaydettik.",
      fullName: "Zeynep M.",
    },
  ];

  const displayTestimonials =
    testimonials && testimonials.length > 0 ? testimonials : testimonialsData;

  // İsimden baş harfleri al
  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  // Rastgele pastel renk
  const getAvatarColor = (index) => {
    const colors = [
      "#3b82f6",
      "#10b981",
      "#8b5cf6",
      "#f59e0b",
      "#ef4444",
      "#06b6d4",
    ];
    return colors[index % colors.length];
  };

  return (
    <section
      id="testimonials"
      style={{
        padding: "80px 0",
        background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)",
      }}
    >
      <Helmet>
        <title>
          {seo.title ||
            "Müşteri Yorumları | Dilan Aslan | Çocuk Gelişim Danışmanlığı"}
        </title>
        <meta
          name="description"
          content={
            seo.description ||
            "Dilan Aslan Çocuk Gelişim Danışmanlığı hakkında müşterilerimizin yorumlarını okuyun."
          }
        />
        <link rel="canonical" href="https://dilanaslan.com/#yorumlar" />
      </Helmet>

      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 24px",
        }}
      >
        {/* Başlık */}
        <motion.div
          style={{ textAlign: "center", marginBottom: "48px" }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span
            style={{
              display: "inline-block",
              backgroundColor: "#fef3c7",
              color: "#d97706",
              padding: "8px 20px",
              borderRadius: "50px",
              fontSize: "0.9rem",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            YORUMLAR
          </span>
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              color: "#0f172a",
              marginBottom: "12px",
            }}
          >
            Müşterilerimiz Ne Diyor?
          </h2>
          <p
            style={{
              fontSize: "1.1rem",
              color: "#64748b",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            Ailelerimizin deneyimlerini ve geri bildirimlerini okuyun
          </p>
        </motion.div>

        {/* Yorumlar Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "24px",
          }}
        >
          {displayTestimonials.map((d, i) => (
            <motion.div
              key={`${d.fullName || "anonim"}-${i}`}
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "28px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                border: "1px solid #f1f5f9",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              {/* Tırnak İkonu */}
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "24px",
                  opacity: 0.1,
                }}
              >
                <FiMessageCircle size={40} color="#3b82f6" />
              </div>

              {/* Yıldızlar */}
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  marginBottom: "16px",
                }}
              >
                {[1, 2, 3, 4, 5].map((star) => (
                  <FiStar key={star} size={18} fill="#fbbf24" color="#fbbf24" />
                ))}
              </div>

              {/* Yorum İçeriği */}
              <p
                style={{
                  color: "#475569",
                  fontSize: "1rem",
                  lineHeight: "1.7",
                  flex: 1,
                  marginBottom: "20px",
                }}
              >
                "{d.content || ""}"
              </p>

              {/* Kullanıcı Bilgisi */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  paddingTop: "16px",
                  borderTop: "1px solid #f1f5f9",
                }}
              >
                {/* Avatar */}
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    backgroundColor: getAvatarColor(i),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1rem",
                  }}
                >
                  {getInitials(d.fullName)}
                </div>
                <div>
                  <p
                    style={{
                      fontWeight: "600",
                      color: "#0f172a",
                      margin: 0,
                      fontSize: "1rem",
                    }}
                  >
                    {d.fullName || "Anonim"}
                  </p>
                  <p
                    style={{
                      color: "#94a3b8",
                      margin: 0,
                      fontSize: "0.85rem",
                    }}
                  >
                    Danışan Ailesi
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Alt CTA */}
        <motion.div
          style={{
            textAlign: "center",
            marginTop: "48px",
          }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <p
            style={{
              color: "#64748b",
              fontSize: "1rem",
              marginBottom: "16px",
            }}
          >
            Siz de deneyiminizi paylaşmak ister misiniz?
          </p>
          <a
            href="https://www.instagram.com/cg.dilanaslan/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#0f172a",
              color: "white",
              padding: "14px 28px",
              borderRadius: "12px",
              fontWeight: "600",
              textDecoration: "none",
              fontSize: "0.95rem",
              transition: "all 0.2s ease",
            }}
          >
            <FiMessageCircle size={18} />
            Yorum Bırakın
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
